import { createRoutine } from 'redux-saga-routines';

const fetchConnectConfig = createRoutine('FETCH_CONNECT_CONFIGS');
const updateConnectConfig = createRoutine('UPDATE_CONNECT_CONFIGS');

export { fetchConnectConfig, updateConnectConfig };
